import { cx } from "@its-engineering-and-development/ui-foundation/utils";

interface SpinnerProps {
    /** Tailwind classes controlling size and color (via `text-*`). */
    className?: string;
}

/**
 * Reusable animated loading spinner. Size and color are driven by `className`
 * (color follows `currentColor`, so set it with a `text-*` utility). Decorative
 * by default (`aria-hidden`); wrap it in a `role="status"` container when it
 * represents a live loading state that needs an accessible name.
 */
export function Spinner({ className = "h-5 w-5 text-current" }: SpinnerProps) {
    return (
        <svg className={cx("animate-spin", className)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
    );
}
